/** Number formatting used across the app (the prototype's `cfM`, `imoney` and chart labels). */

/** "$1,234" (rounded to the dollar; negative shows a minus sign). */
export function money(v: number | undefined | null): string {
  if (v === undefined || v === null || !Number.isFinite(v)) return "—";
  const r = Math.round(v);
  const s = `$${Math.abs(r).toLocaleString("en-CA")}`;
  return r < 0 ? `−${s}` : s;
}

/** "$1,234" of the absolute value. */
export function moneyAbs(v: number | undefined | null): string {
  if (v === undefined || v === null || !Number.isFinite(v)) return "—";
  return money(Math.abs(v));
}

/** "$1,234.56". */
export function money2(v: number): string {
  const s = `$${Math.abs(v).toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
  return v < 0 ? `−${s}` : s;
}

/** Compact: "$7.61M", "$533k", "$950". */
export function moneyShort(v: number): string {
  const a = Math.abs(v);
  const sign = v < 0 ? "−" : "";
  if (a >= 1e6) return `${sign}$${(a / 1e6).toFixed(a >= 1e7 ? 1 : 2)}M`;
  if (a >= 1e4) return `${sign}$${Math.round(a / 1000)}k`;
  return `${sign}$${Math.round(a).toLocaleString("en-CA")}`;
}

/** Axis ticks: "$0", "$2M", "$250k". */
export function moneyTick(v: number): string {
  if (!v) return "$0";
  if (Math.abs(v) >= 1e6) return `$${+(v / 1e6).toFixed(1)}M`;
  return `$${Math.round(v / 1000)}k`;
}

/** "42%". */
export function pct(v: number | undefined, digits = 0): string {
  if (v === undefined || !Number.isFinite(v)) return "—";
  return `${(v * 100).toFixed(digits)}%`;
}

/** "4.79%" from a percent number (rates are stored as percent). */
export function rate(v: number | undefined): string {
  if (v === undefined || !Number.isFinite(v)) return "—";
  return `${+v.toFixed(2)}%`;
}

/** Parses user input like "$1,234", "1234.5" or "4.79%" into a number (undefined when blank). */
export function parseNumber(input: string | number | undefined | null): number | undefined {
  if (input === undefined || input === null) return undefined;
  if (typeof input === "number") return Number.isFinite(input) ? input : undefined;
  const cleaned = input.replace(/[$,%\s]/g, "").replace(/−/g, "-");
  if (cleaned === "" || cleaned === "-") return undefined;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : undefined;
}

/** "1,234" for inputs (no currency sign). */
export function groupDigits(v: number | undefined): string {
  if (v === undefined || !Number.isFinite(v)) return "";
  return Math.round(v).toLocaleString("en-CA");
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}
